<template lang="pug">
base-section#hero-alt(:space='40')
  base-page-content
    .hero-shell
      .hero-frame(aria-hidden='true')
      .hero-copy
        base-display-title.hero-mark(
          title='EOTLAB'
          size='compact'
          tone='accent'
        )
        .hero-title-row
          base-koblenz-arrow.hero-title-arrow
          base-heading.hero-title(:title='title', space='2', weight='500')
</template>

<script setup>
import BaseKoblenzArrow from '~/components/base/KoblenzArrow.vue'

defineOptions({
  name: 'SectionHeroAlt',
})

defineProps({
  title: { type: String, default: 'Title' },
  image: { type: String, default: 'bookshelf.jpg' },
})

provide('heading', { align: 'left' })
</script>

<style scoped>
#hero-alt {
  background:
    radial-gradient(
      circle at top right,
      rgba(0, 192, 216, 0.08),
      transparent 28%
    ),
    linear-gradient(180deg, var(--surface-soft), var(--surface-page));
}

.hero-shell {
  padding: 2rem 1.5rem 1.4rem;
  border: 1px solid var(--border-default);
  background: var(--surface-card);
  border-radius: var(--radius-md);
}

.hero-copy {
  max-width: 42rem;
}

.hero-title-row {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.hero-title-arrow {
  color: var(--brand-primary);
  font-size: clamp(1.4rem, 2.6vw, 2.25rem);
  margin-top: 0;
}

.hero-mark {
  margin-bottom: 0.8rem;
  margin-left: calc(clamp(1.4rem, 2.6vw, 2.25rem) + 0.9rem);
  color: var(--color-accent-soft);
}

.hero-title {
  letter-spacing: -0.03em;
  margin-bottom: 0;
}

:deep(.hero-title) {
  font-size: clamp(2rem, 3.3vw, 3.5rem) !important;
  line-height: 0.95;
}

@media (max-width: 760px) {
  .hero-shell {
    padding: 1.35rem 1rem 1rem;
  }

  .hero-title-row {
    gap: 0.7rem;
  }

  .hero-mark {
    margin-left: calc(clamp(1.4rem, 2.6vw, 2.25rem) + 0.7rem);
  }
}
</style>
